import React , { Component } from 'react';
import HOC from './HOC';
import InputText from '../components/formulario/InputText';
import Radio from '../components/formulario/Radio';
import { CONSTANTES } from '../utils/Constantes';
import Select from '../components/formulario/Select';
import Boton from '../components/formulario/Boton';
import Utils from '../utils/Validate';
import CalendarioRango from '../components/formulario/CalendarioRango';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Modal from 'react-responsive-modal';
import { obtenerRemesas } from '../../service/actions';
import $ from 'jquery';
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import moment from 'moment';
import { Auth, Storage } from 'aws-amplify';
import ModalGenerico from '../components/comunes/ModalGenerico';
import Footer from '../components/comunes/Footer';

class Afiliacion extends Component {
    state = {
        mostrarModal    : false,
        isLoading       : false,
        m_modal         : '',
         casoModal: '',
        pagination: 10,
        pages: 0,
        page: 0,
        filtered: [],
        open: false,
        showBusqueda: 'None',
        disableDiv: false,
        disabledMonto : false,
        idremesa: '',
        //Agregando Nuevo
        pagoFacil: '',
        codigoProducto: '', // del texto
        producto: '', // del combo
        poliza: '',
        tipoDocumento: '',
        numIdTercero: '',
        numeroDocumento: '',
        disabledNumdoc: false,
        disabledTipoDoc: false,
        disabledEnviar: false,
        aseguradoNombre: '',
        aseguradoApellidoPat: '',
        aseguradoApellidoMat: '',
        tipoOperacionCob: '',
        tipoTarjeta: 'NUEVA TARJETA',
        tipoOperacion: '',
        numCuotas: '',
		emailAsesor: '',
        emailCliente: '',
		moneda: '',
		total: '',
        usuario: '',
        disabledCuota:true,
        v_pagoFacil: '',
        v_numeroDocumentoCobro: '',
        v_poliza: '',
        v_tipoDocumento: '',
        v_numeroDocumento: '',
        v_aseguradoNombre: '',
        v_aseguradoApellidoPat: '',
        v_aseguradoApellidoMat: '',
        v_producto: '',
        v_poliza: '',
        v_tipoOperacionCob:'',
        v_tipoOperacion: '',
        v_numCuotas: '',
        v_emailAsesor: '',
        v_emailCliente: '',
        v_moneda: '',
        v_total: '',
        v_codigoProducto: '',
        lstTarjeta: [
            {
                name:"tipoTarjeta",
                value: "2",
                detalle: 'NUEVA TARJETA',
                checked: true
            },
        ],
        listaTipoDocumentos: [
            {
                value: "2",
                detalle: 'DNI'
            },
            {
                value: "4",
                detalle: 'CARNET DE EXTRANJERIA'
            },
            {
                value: "6",
                detalle: 'PASAPORTE'
            }
		],
        listaProducto: [
            {
                value: "VE",
                detalle: 'VEHICULAR'
            },
            {
                value: "RG",
                detalle: 'RIESGOS GENERALES'
            },
            {
                value: "VIDA",
                detalle: 'VIDA'
            },
            {
                value: "SD",
                detalle: 'SALUD'
            }
        ],
        listaOperacionCob: [
            {
                value: "PAGO_EN_LINEA",
                detalle: 'PAGO EN LINEA'
            },
            {
                value: "PAGO_EN_LINEA_SUSCRIPCION",
                detalle: 'PAGO EN LINEA SUSCRIPCION'
            },
            {
                value: "SUSCRIPCION",
                detalle: 'SUSCRIPCION'
            } 
        ],
		listaOperacion: [
            {
                value: "CVC",
                detalle: 'CAMBIO DE MEDIO DE PAGO'
            },
            {
                value: "FIN",
                detalle: 'FINANCIAMIENTO'
            }
        ],
        listaCuotas: [
            {
                value: "1",
                detalle: '01'
            },
            {
                value: "2",
                detalle: '02'
            },
            {
                value: "3",
                detalle: '03'
            },
            {
                value: "4",
                detalle: '04'
            },
            {
                value: "5",
                detalle: '05'
            },
            {
                value: "6",
                detalle: '06'
            },
            {
                value: "7",
                detalle: '07'
            },
            {
                value: "8",
                detalle: '08'
            },
            {
                value: "9",
                detalle: '09'
            },
            {
                value: "10",
                detalle: '10'
            },
            {
                value: "11",
                detalle: '11'
            },
            {
                value: "12",
                detalle: '12'
            }
        ],
        listaMoneda: [
            {
                value: "PEN",
                detalle: 'Soles'
            },
            {
                value: "USD",
                detalle: 'Dolares'
            }
        ],
        //
        cantidadRemesas:0,
        listaRemesas: this.props.listaRemesas,
        paginacion:[],
        listaDetalleRemesas:[],
        formValido: true,
        nohayremesas:false,
        buscadorMobile: "",
        intervalId: "",
    }

    disableDiv = () => {
        this.setState({
           disableDiv:true
        });
    }

    enableDiv = () => {
        this.setState({
           disableDiv:false
        });
    }

    previousPageHandler = () => {
        this.setLocalStorage("FLUJO","1");
        this.props.props.history.push({ pathname : CONSTANTES.RUTA.detalle });
    }

    onOpenModal = (remesaId) => (e)  => {
        let request = { 
            remesaId: remesaId
        };
        this.props.mostrarLoading();
        this.props.props.callService("GET","remesas", {...request}, obtenerRemesas).then(response => {
            // console.error(response);
            if(response){
                if(200 === response.status){    
                    let detalleremesasFinalizadas = [];
                    if(Object.values(response.data.listaremesas).length > 0){
                        Object.values(response.data.listaremesas).map(item => {
                            Object.values(item).map(dato => {
                                detalleremesasFinalizadas.push(dato);
                                return detalleremesasFinalizadas;
                            })
                            return item;
                        });
                    }
                    this.setState({ listaDetalleRemesas: Object.values(detalleremesasFinalizadas) });
                }
                this.props.ocultarLoading();
                this.setState({ open: true, idremesa: remesaId});
            }
            else if(response === undefined)
            {
                this.props.ocultarLoading();
                this.cerrarSesion();
            }
        }).catch( error => {
            console.error(error);
            this.props.ocultarLoading();
            this.setState({ open: true, idremesa: remesaId});
            this.props.mostrarModal("mensajeUsuario", null, "Hemos tenido problemas con nuestro sistema.");
        });
    };

    onCloseModal = ()  => {
        this.setState({ open: false, listaDetalleTransacciones: [] });
    };

    setLocalStorage = (key, value) => {
        localStorage.setItem(key, JSON.stringify(value));
      }
    
      getLocalStorage = (key) => {
        if(localStorage.hasOwnProperty(key)){
          const local = localStorage.getItem(key);
          return JSON.parse(local);
        }else{
          return {};
        }
        
      }

    componentWillMount() {
    }

    async componentDidMount(){

		if("true" !== localStorage.getItem('login')){
            await Auth.signOut();
        }
        this.setState({
            fechaInicial: localStorage.getItem("fechaInicial"),
            fechaFinal : localStorage.getItem("fechaFinal"),
        });
        //var intervalId = setInterval(this.timer.bind(this), 5000);
        //this.setState({intervalId: intervalId});
        Auth.currentUserInfo().then(response => {
           console.log("response de afliacion::::", response);
           if (response && response.attributes != null){ // forzaron el cierre de sesión
              this.setState({
                usuario: response && response.attributes.email ? response.attributes.email : ''
              });
            }
        });

    }

    timer = () => {
        Auth.currentSession().then(response =>{
            var exp = moment.unix(response.accessToken.payload.exp).format('DD/MM/YYYY hh:mm:ss');
            var fecha_actual = moment(new Date()).format('DD/MM/YYYY hh:mm:ss');
            if(fecha_actual > exp){
                this.cerrarSesion();
            }
		})
		.catch(error =>{
			this.props.props.history.push({ pathname : CONSTANTES.RUTA.login }); 
		});
    }

    validarFormulario = (e) => {
        let { value , name } = e.target;
        this.setState({['v_' + name] : Utils.validarCampo(name, value)}, () => {
            this.setState({formValido : Utils.validarFormState(this.state, 'filtro')})
        })   
    }

    onChange = (e) => {
        let { name, value } = e.target;    
      
        if( "ideDireccion" === name ){
            this.setState({
                [name]: value.split(CONSTANTES.SEPARADOR)[0],
                formValido: true,
                ["dsc"+name.substring(3, name.length)] :  value.split(CONSTANTES.SEPARADOR)[1],
            }, () => {
            });
        }
        else if("numeroDocumentoCobro" === name)
        {
            const re = /^[0-9\b]+$/;
            if (value === '' || re.test(value)) {
                this.setState({ [name] : value });
            }
        }else if("tipoOperacion" === name)
        {
            var ltipOper = value.split(CONSTANTES.SEPARADOR)[0];
            this.state.disabledCuota = false;
            this.state.numCuotas = '';
            if (ltipOper === 'CVC'){
                this.state.numCuotas = CONSTANTES.SEPARADOR;
                this.state.disabledCuota = true;
            }
            this.setState({ [name] : value }, () => {
            });

        }else if("tipoOperacionCob" === name)
        {
            var ltipOper = value.split(CONSTANTES.SEPARADOR)[0];
            this.state.disabledMonto = false;
            if (ltipOper === 'SUSCRIPCION'){
                this.state.total = "0";
                this.state.disabledMonto = true;
            }

            this.setState({ [name] : value }, () => {
            });

        }
        else if("pagoFacil" === name)
        {
            const re = /^[0-9\b]+$/;
            if (value === '' || re.test(value)) {
                this.setState({ [name] : value });
            }
        }
        else if("codigoProducto" === name)
        {
            const re = /^[0-9\b]+$/;
            if (value === '' || re.test(value)) {
                this.setState({ [name] : value });
            }
        }
        else if("total" === name)
        {
            const re = /^[0-9.\b]+$/;
            if (value === '' || re.test(value)) {
                this.setState({ [name] : value });
            }
        }
        else{
            this.setState({ [name] : value }, () => {
            });
        }
    }

    handleChange = (e) => {
        let { name, value } = e.target; 
        this.setState({loteId: e.target.value})
        this.setState({ [name] : value }, () => {
        });
        if(e.target.value !== "")
        {
            $("#calendarPortalCobranzas").css("display", "none");
        } else{
            $("#calendarPortalCobranzas").css("display", "block");
        }
      } 

    onChangeRangoFechas = (fechaInicial, fechaFinal) => {
        this.setState({
            fechaInicial, fechaFinal,
            v_fecha: true,
            formValido: true,
        }, () => {
        });
        localStorage.setItem('fechaInicial', fechaInicial);
        localStorage.setItem('fechaFinal', fechaFinal); 
    }

    cerrarSesion = () => {
        this.props.mostrarLoading();      
        new Promise((resolve, reject) => {
          setTimeout(function(){
			//localStorage.clear();
			
            resolve(true);
          },500)
        }).then(() => {
          this.props.ocultarLoading();
          this.props.props.history.push({ pathname : CONSTANTES.RUTA.login });
        })
      }

    mostrarModal = (casoModal, m_modal) => {
        this.setState({
          casoModal,
          m_modal,
          mostrarModal: true,
        })
      }

    validarEnvio = () => {
         let regExp = /\S+@\S+\.\S+/;
        //console.log("numIdTercero::::" + this.state.numIdTercero); 
        
        if (this.state.producto === CONSTANTES.SEPARADOR || this.state.producto === ''){
            this.mostrarModal('mensaje', 'Seleccione Producto');
            return 0;
        }else if (this.state.tipoOperacion === CONSTANTES.SEPARADOR || this.state.tipoOperacion === ''){
            this.mostrarModal('mensaje', 'Seleccione Tipo de Operación');
            return 0;
        }else if (this.state.tipoOperacionCob === CONSTANTES.SEPARADOR || this.state.tipoOperacionCob === ''){
            this.mostrarModal('mensaje', 'Seleccione Operación Cobranza');
            return 0;
        }else if ( this.state.poliza === ''){
            this.mostrarModal('mensaje', 'Ingrese Numero de Poliza');
            return 0;
        }else if ( this.state.emailCliente === ''){
            this.mostrarModal('mensaje', 'Ingrese un email de cliente valido');
            return 0;
        }else if ( !regExp.test( this.state.emailCliente) ){
            this.mostrarModal('mensaje', 'Ingrese un Email de cliente Valido');
            return 0;
        }else if ( this.state.total === ''){
            this.mostrarModal('mensaje', 'Ingrese un Monto valido');
            return 0;
        }else if (this.state.moneda === CONSTANTES.SEPARADOR || this.state.moneda === ''){
            this.mostrarModal('mensaje', 'Seleccione Una Moneda Valida');
            return 0;
        }
        if (this.state.tipoOperacion.split(CONSTANTES.SEPARADOR)[0] == "FIN" && this.state.numCuotas === CONSTANTES.SEPARADOR){
            this.mostrarModal('mensaje', 'Seleccione El número de cuotas');
            return 0;
        }
        if ((this.state.numIdTercero == null || this.state.numIdTercero == undefined 
            || this.state.numIdTercero == '' || this.state.numIdTercero == '0' ||  this.state.numIdTercero == 'null') 
            && this.state.tipoOperacionCob.split(CONSTANTES.SEPARADOR)[0] != 'PAGO_EN_LINEA'){
            this.mostrarModal('mensaje', 'Operacion no permitida para el cliente, solo puede realizar pago en linea');
            return 0;
        }
        // vlidar si this.state.numIdTercero == null y estado es suscripcion y pago suscripcion entonces la operacción no permitida
        

        return 1;
    }


    enviarCorreo = () => {
        if (this.validarEnvio()){ 
            let request = { 
                 numId: this.state.numIdTercero,
                 nombres: this.state.aseguradoNombre,
                 apePat: this.state.aseguradoApellidoPat,
                 apeMat: this.state.aseguradoApellidoMat,
                 tipDoc: this.state.tipoDocumento.split(CONSTANTES.SEPARADOR)[0],
                 numDoc: this.state.numeroDocumento,
                 tipOpeCob: this.state.tipoOperacionCob.split(CONSTANTES.SEPARADOR)[0],
                 tipOp:  this.state.tipoOperacion.split(CONSTANTES.SEPARADOR)[0],
                 producto: this.state.producto.split(CONSTANTES.SEPARADOR)[0],
                 codProd: this.state.codigoProducto,
                 numPoliza: this.state.poliza,
                 numCoutas: this.state.numCuotas.split(CONSTANTES.SEPARADOR)[0],
                 emailCliente: this.state.emailCliente,
                 emailAsesor: this.state.emailAsesor,
                 moneda: this.state.moneda.split(CONSTANTES.SEPARADOR)[0],
                 monto: this.state.tipoOperacionCob.split(CONSTANTES.SEPARADOR)[0] == "SUSCRIPCION" ? "0" : this.state.total
            };
            //console.log("Request:::::::", request);
            this.props.mostrarLoading();
            this.props.props.callService("POST","afiliacion", {...request}, null).then(response => {

                let data = response.data.message;
                    //console.log("data", data);
                if (response.data.status == 200){
                    //console.log("datos enviados ::::", response);
                    this.props.ocultarLoading();
                    this.limpiarBusqueda();
                    this.mostrarModal('mensaje', 'EL CORREO SE ENVIÓ CON ÉXITO');
                }else if (response.data.status == 406){
                    this.mostrarModal('mensaje', 'Su sesión ha sido cerrada desde otro dispositivo, se cerrará la sesión');
                    new Promise((resolve, reject) => {
                        setTimeout(function(){
                        //localStorage.clear();
                        Auth.signOut();
                        resolve(true);
                        },1500);
                
                    }).then(() => {
                        const indexURL = window.location.href.indexOf(CONSTANTES.RUTA.basename);
                        const urlRedirect = window.location.href.substring(0, indexURL);
                        window.location.href = urlRedirect + CONSTANTES.RUTA.basename + CONSTANTES.RUTA.login;
                    });
                }else{
                    this.props.ocultarLoading();
                    if (data == 'undefined'){
                        data = " error de datos ingresados, verifique con el administrador"
                    }
                    this.mostrarModal('mensaje', 'Ocurrio un error al registrar los datos ' + data);
                }
            }).catch( err => {
                console.log(err);
                this.props.ocultarLoading();
            }); 
        }
    }

    limpiarBusqueda = () => {
        this.props.mostrarLoading();
        this.state.numeroDocumento = '';
        this.state.showBusqueda = 'None';
        this.state.aseguradoNombre = '';
        this.state.aseguradoApellidoPat = '';
        this.state.aseguradoApellidoMat = '';
        this.state.tipoDocumento  = '';
        this.state.numeroDocumento  = '';
        this.state.tipoOperacionCob  = '';
        this.state.tipoOperacion   = '';
        this.state.producto  = '';
        this.state.codigoProducto   = '';
        this.state.poliza   = '';
        this.state.numCuotas   = '';
        this.state.emailCliente   = '';
        this.state.emailAsesor  = '';
        this.state.moneda   = '';
        this.state.total   = '';
        this.state.numIdTercero = '';
        this.state.disabledNumdoc = false;
        this.state.disabledTipoDoc = false;
        this.state.disabledMonto = false;
        this.props.ocultarLoading();
    }
    limpiarPreResultado= () => {
        this.state.aseguradoNombre = '';
        this.state.aseguradoApellidoPat = '';
        this.state.aseguradoApellidoMat = '';
        this.state.tipoOperacionCob  = '';
        this.state.tipoOperacion   = '';
        this.state.producto  = '';
        this.state.codigoProducto   = '';
        this.state.poliza   = '';
        this.state.numCuotas   = '';
        this.state.emailCliente   = '';
        this.state.emailAsesor  = '';
        this.state.moneda   = '';
        this.state.total   = '';
        this.state.numIdTercero = '';
    }

    buscarTercero = () => {
        //console.log("ripodocuento:::" + this.state.tipoDocumento);
        if (this.state.numeroDocumento == '' || (this.state.tipoDocumento == '' || this.state.tipoDocumento == CONSTANTES.SEPARADOR)){
            this.mostrarModal('mensaje', 'Ingrese Criterios Valido de busqueda');
        }else{
            
            let request = { 
                tipDoc: this.state.tipoDocumento.split(CONSTANTES.SEPARADOR)[0],
                numDoc: this.state.numeroDocumento,
                accion: "getTercero"
            };  
            this.props.mostrarLoading();
             
            this.props.props.callService("POST","afiliacion", {...request}, null).then(response => {
               console.log(response);
               this.state.showBusqueda = '';
                this.limpiarPreResultado();
                let data = response.data.message;
                if (response.data.status == 200){
                    //console.log("data", data);
                    if (isNaN(Number(data.tercero))){
                        data.tercero = '0'; // si no es un numero enviamos 0
                    }
                    this.state.disabledNumdoc = true;
                    this.state.disabledTipoDoc = true;
                  //  this.state.tipoDocumento = "" + data.tipoDocumento;
                    this.state.numeroDocumento =  data.numeroDocumento;
                    this.state.aseguradoNombre = data.nombres;
                    this.state.aseguradoApellidoPat = data.apellidoPaterno;
                    this.state.aseguradoApellidoMat = data.apellidoMaterno;
                    this.state.numIdTercero = data.tercero;
                    this.state.emailCliente = data.correo;
                    this.state.emailAsesor = this.state.usuario;
                    this.state.showBusqueda = '';
                   
                }else if (response.data.status == 406){
                    this.mostrarModal('mensaje', 'Su sesión ha sido cerrada desde otro dispositivo, se cerrará la sesión');
                    // new Promise((resolve, reject) => {
                    //     setTimeout(function(){
                    //     //localStorage.clear();
                    //     Auth.signOut();
                    //     resolve(true);
                    //     },1500);
                
                    // }).then(() => {
                    //     const indexURL = window.location.href.indexOf(CONSTANTES.RUTA.basename);
                    //     const urlRedirect = window.location.href.substring(0, indexURL);
                    //     window.location.href = urlRedirect + CONSTANTES.RUTA.basename + CONSTANTES.RUTA.login;
                    // });
                }
                else{
                    this.mostrarModal('mensaje', 'El documento no existe');
                    this.state.showBusqueda = 'None'; // comentar luego ya que por error no debe entrar
                    this.state.disabledNumdoc = false;
                    this.state.disabledTipoDoc = false;
                }
                this.props.ocultarLoading();
            }).catch( err => {
                this.state.showBusqueda = 'None'; // comentar luego ya que por error no debe entrar
                this.state.disabledNumdoc = false;
                this.state.disabledTipoDoc = false;
                console.log(err);
                this.props.ocultarLoading();
            });
        }
    }

    onFilteredChangeCustom = (value, accessor) => {
        let filtered = this.state.filtered;
        let insertNewFilter = 1;
        if (filtered.length) {
          filtered.forEach((filter, i) => {
            if (filter["id"] === accessor) {
              if (value === "" || !value.length) filtered.splice(i, 1);
              else filter["value"] = value;
    
              insertNewFilter = 0;
            }
          });
        }
        if (insertNewFilter) {
          filtered.push({ id: accessor, value: value });
        }
        this.setState({ filtered: filtered });
    }

    addCommas(nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1,$2');
        }
        return x1 + x2;
    }

   

    render(){
        const fontSize = 11;
        const { open, listaRemesas, page } = this.state;
        return(
            <div className="w100 d-flex mb-flex-column justify-content-between">
                                <div className={( this.state.buscadorMobile )+" boxBuscar mb-w100 d-flex flex-column flex-justify-between w100"}>
                                <div className="banner banner-white d-flex justify-content-center mb-display-none ">
                                    <div className="boxBanner boxBanner-white d-flex justify-content-between align-items-center">
                                        <div className="tituloBanner">
                                            <p><b>Afiliacion {this.state.currentCount}</b></p>
                                        </div>
                                    </div>
                                </div>
                                    <div className="seccionFiltrarAfiliado">
                                        <p className="tituloBuscar" ><span>Filtra </span>tu búsqueda: </p>
                                        {localStorage.getItem("NombreArchivo") != null ?
                                        <p>Nombre Archivo: <b>{localStorage.getItem("NombreArchivo")}</b></p>                                       
                                        : null}                                        
                                        <Row>
                                                <Col className="s12 m4 l4">
                                                    <Select 
                                                        lista = {this.state.listaTipoDocumentos}                                                 
                                                        titulo = "Tipo Doc."                                                
                                                        name = "tipoDocumento"
                                                        habilitarValorInicial = {true}
                                                        disabledSelect = {this.state.disabledTipoDoc}
                                                        value = {this.state.tipoDocumento}
                                                        onChange = {(e) => { 
                                                                            this.onChange(e); 
                                                                            this.validarFormulario(e);
                                                                    }}
                                                        placeholder = 'Tipo Doc.'
                                                        validate = {this.state.v_tipoDocumento}/>
                                                </Col>
                                                <Col className="s12 m4 l4">
                                                    <InputText
                                                        name="numeroDocumento"
                                                        value={this.state.numeroDocumento}
                                                        disabled = {this.state.disabledNumdoc}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        placeholder="Num. Doc."
                                                        validate = {this.state.v_numeroDocumento}   />
                                                </Col>
                                        </Row>
                                       
                                        <Row>                                                
                                                <Col className="s12 m4 l3" style={{float: "left"}}>
                                                    <button className={"botonFormulario left btn-small no-box-shadow"} onClick={this.limpiarBusqueda} style={{marginLeft: "10px", width: "40%"}}>Limpiar</button>
                                                    <button className={"botonFormulario right btn-small no-box-shadow"} onClick={this.buscarTercero}  style={{marginBottom: "10px", width: "40%"}}>Buscar</button>
                                                </Col>
                                        </Row> 
                                    </div>
                                    <div className="seccionResultadoAfiliado" style={{ display: this.state.showBusqueda } }>
                                        <p className="tituloBuscar" ><span>Resultado de </span>tu búsqueda: </p>
                                        {localStorage.getItem("NombreArchivo") != null ?
                                        <p>Nombre Archivo: <b>{localStorage.getItem("NombreArchivo")}</b></p>                                       
                                        : null}                                        
                                        <Row>
                                                <Col className="s12 m4 l4">
                                                    <InputText
                                                        name="aseguradoNombre"
                                                        value={this.state.aseguradoNombre}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        placeholder="Nombres"
                                                        disabled={true}
                                                        validate = {this.state.v_aseguradoNombre}   />
                                                </Col>
                                                <Col className="s12 m4 l4">
                                                    <InputText
                                                        name="aseguradoApellidoPat"
                                                        value={this.state.aseguradoApellidoPat}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        placeholder="Apellido Paterno"
                                                        disabled={true}
                                                        validate = {this.state.v_aseguradoApellidoPat}   />
                                                </Col>
                                                <Col className="s12 m4 l3">
                                                    <InputText
                                                        name="aseguradoApellido"
                                                        value={this.state.aseguradoApellidoMat}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        placeholder="Apellido Materno"
                                                        disabled={true}
                                                        validate = {this.state.v_aseguradoApellidoMat}   />
                                                </Col>
                                        </Row>
                                        {localStorage.getItem("NombreArchivo") != null ?
                                        <p>Nombre Archivo: <b>{localStorage.getItem("NombreArchivo")}</b></p>                                       
                                        : null}                                        
                                        <Row>
                                                <Col className="s12 m4 l3">
                                                    <Radio
                                                        name="tipoTarjeta"
                                                        opciones={this.state.lstTarjeta}
                                                        titulo="Tarjeta"
                                                        clase="clsTarjeta"
                                                        onChange={this.onChange}
                                                        value={this.state.tipoTarjeta}
                                                         />
                                                </Col>
                                        </Row>
                                     
                                        <p className="tituloBuscar" >Operaciones </p>
                                        {localStorage.getItem("NombreArchivo") != null ?
                                        <p>Nombre Archivo: <b>{localStorage.getItem("NombreArchivo")}</b></p>                                       
                                        : null}                                        
                                        <Row>
                                                <Col className="s12 m4 l3">
                                                    <Select 
                                                        lista = {this.state.listaProducto}                                                 
                                                        titulo = "Producto"                                                
                                                        name = "producto"
                                                        habilitarValorInicial = {true}
                                                        value = {this.state.producto}
                                                        onChange = {(e) => { 
                                                                            this.onChange(e); 
                                                                            this.validarFormulario(e);
                                                                    }}
                                                        placeholder = 'Producto'
                                                        validate = {this.state.v_producto}/>
                                                </Col>
                                                <Col className="s12 m4 l4">
                                                    <Select 
                                                        lista = {this.state.listaOperacionCob}                                                 
                                                        titulo = "Operación "                                                
                                                        name = "tipoOperacionCob"
                                                        habilitarValorInicial = {true}
                                                        value = {this.state.tipoOperacionCob}
                                                        onChange = {(e) => { 
                                                                            this.onChange(e); 
                                                                            this.validarFormulario(e);
                                                                    }}
                                                        placeholder = 'Operación Cobranza'
                                                        validate = {this.state.v_tipoOperacionCob}/>
                                                </Col>
                                                <Col className="s12 m4 l4">
                                                    <Select 
                                                        lista = {this.state.listaOperacion}                                                 
                                                        titulo = "Operación Cob."                                                
                                                        name = "tipoOperacion"
                                                        habilitarValorInicial = {true}
                                                        value = {this.state.tipoOperacion}
                                                        onChange = {(e) => { 
                                                                            this.onChange(e); 
                                                                            this.validarFormulario(e);
                                                                    }}
                                                        placeholder = 'Tipo de Operación'
                                                        validate = {this.state.v_tipoOperacion}/>
                                                </Col>
                                                
                                        </Row>
                                        <Row>
                                                <Col className="s12 m4 l3">
                                                    <InputText
                                                        name="codigoProducto"
                                                        value={this.state.codigoProducto}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        placeholder="Cod. de Producto"
                                                        validate = {this.state.v_codigoProducto}   />
                                                </Col>
                                                <Col className="s12 m4 l4">
                                                    <InputText
                                                        name="poliza"
                                                        value={this.state.poliza}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        placeholder="Número de Poliza"
                                                        validate = {this.state.v_poliza}   />
                                                </Col>
                                                <Col className="s12 m4 l4">
                                                    <Select 
                                                        lista = {this.state.listaCuotas}                                                 
                                                        titulo = "Cuotas."                                                
                                                        name = "numCuotas"
                                                        habilitarValorInicial = {true}
                                                        value = {this.state.numCuotas}
                                                        disabledSelect = {this.state.disabledCuota}
                                                        onChange = {(e) => { 
                                                                            this.onChange(e); 
                                                                            this.validarFormulario(e);
                                                                    }}
                                                        placeholder = 'Numero de cuotas'
                                                        validate = {this.state.v_numCuotas}/>
                                                </Col>
                                                
                                        </Row>
                                        <Row>
                                                <Col className="s12 m4 l4">
                                                    <InputText
                                                        name="emailAsesor"
                                                        value={this.state.emailAsesor}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        placeholder="Email Asesor"
                                                        disabled={true}
                                                        validate = {this.state.v_emailAsesor}   />
                                                </Col>

                                                <Col className="s12 m4 l7">
                                                    <InputText
                                                        name="emailCliente"
                                                        value={this.state.emailCliente}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        disabled={false}
                                                        placeholder="Email Cliente "
                                                        validate = {this.state.v_emailCliente}   />
                                                </Col>

                                        </Row>
                                        <Row>
                                               <Col className="s12 m4 l4">
                                                    <Select 
                                                        lista = {this.state.listaMoneda}                                                 
                                                        titulo = "Moneda"                                                
                                                        name = "moneda"
                                                        habilitarValorInicial = {true}
                                                        value = {this.state.moneda}
                                                        onChange = {(e) => { 
                                                                            this.onChange(e); 
                                                                            this.validarFormulario(e);
                                                                    }}
                                                        placeholder = 'Moneda'
                                                        validate = {this.state.v_moneda}/>
                                                </Col>
                                                <Col className="s12 m4 l3">
                                                    <InputText
                                                        name="total"
                                                        value={this.state.total}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        disabled={this.state.disabledMonto}
                                                        placeholder="Monto"
                                                        validate = {this.state.v_total}   />
                                                </Col>
                                        </Row>
                                        <Row>                                                
                                                <Col className="s12 m4 l3" style={{float: "left"}}>
                                                    <button className={"botonFormulario right btn-small no-box-shadow"} onClick={this.enviarCorreo} disabled={this.state.disabledEnviar} style={{marginBottom: "10px", width: "50%"}}>Enviar Correo</button>
                                                </Col>
                                        </Row> 
                                    </div>
                                </div>
                                <Modal open={open} onClose={this.onCloseModal} center>
                                    <div className="boxModalPoliticas">
                                        <div className="headerModalPoliticas">
                                            DETALLE DE REMESA
                                        </div>
                                        <div className="bodyModalPoliticas">                                       
                                            <Editor
                                                value={this.state.listaDetalleRemesas[0]}
												sortObjectKeys={true}
												mode={"view"}
                                            />
                                        </div>
                                    </div>
                                </Modal>
                                <ModalGenerico 
                                    caso={this.state.casoModal}
                                    mostrar={this.state.mostrarModal}
                                    mensaje={this.state.m_modal}
                                    cerrarModal={ () => this.setState({ mostrarModal: false }) } />
                                
            </div>
            
        );
    }
}
export default HOC(Afiliacion);